<template lang="pug">
page-template.page-contact(title="Trabalhe Conosco")
  work-with-us.mb-4.mb-md-0.mx-auto(
    :action="server + '/rest/email/work-with-us'"
  )
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import WorkWithUs from "@/components/forms/WorkWithUs";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  components: {
    PageTemplate,
    WorkWithUs,
  },
};
</script>
